import type { StudyStatus } from "@/routes/(app)/_app.study.$studyId";
import type { WorkshopData } from "@/api/api";

export const setBreadcrumb = (type: StudyStatus): string => {
	if (type.toLowerCase().includes("kurs online")) {
		return "Szkolenie online";
	}
	return type;
};

interface RedirectionAuthParameters {
	params: {
		slugId: string;
	};
	search: {
		status: StudyStatus;
	};
	to: string;
}

interface RedirectionNoAuthParameters {
	params: {
		workshopId: string;
	};
	search: {
		status: StudyStatus;
	};
	to: string;
}

type RedirectionByAuthStatusFn = (
	workshop: WorkshopData,
	isAuthenticated: boolean
) => RedirectionAuthParameters | RedirectionNoAuthParameters;

export const redirectionByAuthStatus: RedirectionByAuthStatusFn = (
	workshop,
	isAuthenticated
) => {
	if (isAuthenticated) {
		return {
			params: { slugId: workshop.slug },
			search: { status: workshop.type_field as StudyStatus },
			to: "/workshops/$type/$slugId/auth",
		};
	}
	return {
		params: { workshopId: workshop.id.toString() },
		search: { status: workshop.type_field as StudyStatus },
		to: "/workshops/$type/$workshopId",
	};
};

type RedirectionByAuthStatusByTypeFn = (
	type: "training" | "webinar",
	workshop: WorkshopData,
	isAuthenticated: boolean
) => RedirectionAuthParameters | RedirectionNoAuthParameters;

export const redirectionByAuthStatusByType: RedirectionByAuthStatusByTypeFn = (
	type,
	workshop,
	isAuthenticated
) => {
	if (isAuthenticated) {
		return {
			params: { slugId: workshop.slug },
			search: { status: workshop.type_field as StudyStatus },
			to: `/workshops/${type}/$slugId/auth`,
		};
	}
	return {
		params: { workshopId: workshop.id.toString() },
		search: { status: workshop.type_field as StudyStatus },
		to: `/workshops/${type}/$workshopId`,
	};
};
